import { Box, Typography } from '@material-ui/core';
import React, { useMemo, useState } from 'react';
import { TabletButton } from '@campfire/tablet-button';
import { Settings } from '@material-ui/icons';
import { useUser } from '../../../../../../global/auth/useUser';
import { useCampfireTheme } from '../../../../../../theme/useCampfireTheme';
import { AccountSettingsDialog } from '../../../../user-profile/account-settings/AccountSettingsDialog';
import { Avatar } from '../../../../user-profile/components/Avatar';
import { SideBarProfileSectionSkeleton } from './SideBarProfileSectionSkeleton';
import { useVolDashboardMyElementsContext } from '../../VolDashboardMyElementsContext';

export const SideBarProfileSection = () => {
  const [openEditProfileDialog, setOpenEditProfileDialog] = useState(false);

  const { theme } = useCampfireTheme();
  const {
    user: { userIdentityService },
  } = useUser();

  const { profile, activityEnrolments, sidebarLoading, sidebarRefetch } = useVolDashboardMyElementsContext();

  const volunteerPosition: string = useMemo(() => {
    if (!profile) {
      return 'General Volunteer';
    }

    const { isProgramManager, isVmAdmin } = userIdentityService;

    if (isVmAdmin) {
      return 'Admin';
    }

    if (isProgramManager) {
      return 'Program Manager';
    }

    const isActivityLeader = activityEnrolments?.some(({ position }) => position === 'al') ?? false;

    if (isActivityLeader) {
      return 'Activity Leader';
    }

    return 'General Volunteer';
  }, [profile, activityEnrolments, userIdentityService]);

  return (
    <>
      {sidebarLoading ? (
        <SideBarProfileSectionSkeleton />
      ) : profile ? (
        <Box padding='24px 0px' display='flex' alignItems='center'>
          <Avatar
            size={110}
            avatarUrl={profile.avatarUrl}
            preferredName={profile.preferredName}
            lastName={profile.lastName}
          />
          <Box marginLeft='24px'>
            <Typography
              variant='h4'
              style={{
                color: theme.color.black,
                fontSize: '20px',
                fontWeight: 800,
                whiteSpace: 'break-spaces',
                letterSpacing: '-0.02em',
              }}
            >{`${profile.preferredName} ${profile.lastName}`}</Typography>
            <Typography variant='body2'>{volunteerPosition}</Typography>
            <TabletButton
              size='small'
              variant='contained'
              color='default'
              aria-controls='options-menu'
              aria-haspopup='true'
              onClick={() => setOpenEditProfileDialog(true)}
              startIcon={<Settings />}
              style={{
                height: '100%',
                border: '1px solid transparent',
                boxSizing: 'border-box',
                borderRadius: '4px',
                padding: '5px 10px',
                marginRight: '10px',
                marginTop: '10px',
                color: '#545454',
                borderColor: '#888',
                marginLeft: 'auto',
              }}
            >
              Account Settings
            </TabletButton>
          </Box>
        </Box>
      ) : null}
      <AccountSettingsDialog open={openEditProfileDialog} setOpen={setOpenEditProfileDialog} refetch={sidebarRefetch} />
    </>
  );
};
